import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

export const trackSelectGoal = ({ goal }) => {
  ga.track('select_goal', {
    goal_type: goal,
  })
  amplitude.track('user_manage_personal_info', {
    ...baseWebEventProps(),
    action_name: 'manage',
    action_type: 'active',
    measurement: 'goal',
    measurement_value: goal,
    measurement_context: 'onboarding',
  })
}
